export default __webpack_public_path__ + "static/media/single-right-border-left.cb87ca3a.svg";